import styled from 'styled-components'

import ActionButton from '../ActionButton'
import Icon from '../Icon'
import breakpoints from '../../theme/breakpoints'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.egyptianBlue};
  position: relative;
  max-height: 14rem;
`

export const Title = styled.h3`
  ${({ theme }) => theme.textStyles.H3};
  color: ${({ theme }) => theme.colors.pureWhite};
  margin: 5.9rem 0;
  display: flex;
  align-items: flex-end;
  text-align: center;

  ${breakpoints.up('tablet')} {
    align-items: center;
  }
`

export const Button = styled(ActionButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 1.3rem;
`

export const FaqButton = styled(ActionButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 2.3rem;
`

export const StyledIcon = styled(Icon)`
  width: 3rem;
  height: 3rem;
  transform: translateX(-2rem);

  ${breakpoints.up('tablet')} {
    transform: none;
    margin-left: 1.2rem;
  }
`
